import http from '@/utils/http';

export const addReport = (params: IReportReq & IReportMutationParams): IBaseResponse<IReport> => {
  return http({
    url: '/api/v1/intelligence_pc/user/report/add',
    method: 'post',
    data: params,
    rawData: true,
    errorHandler: true,
  }) as any;
};

export const updateReport = (params: IReportReq & IReportMutationParams): IBaseResponse => {
  return http({
    url: '/api/v1/intelligence_pc/user/report/update',
    method: 'post',
    data: params,
    rawData: true,
    errorHandler: true,
  }) as any;
};

export const deleteReports = (params: { admin_mode: boolean; resource_ids: string[] }): IBaseResponse => {
  return http({
    url: '/api/v1/intelligence_pc/user/report/delete',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};

export const fetchReports = (params: {
  admin_mode: boolean;
  resource_ids?: string[];
  keyword?: string;
  order_by?: string[];
  page?: number;
  page_size?: number;
}): IBaseResponse<IPaginationData<IReportReq>> => {
  return http({
    url: '/api/v1/intelligence_pc/user/report/list',
    method: 'post',
    data: params,
    rawData: true,
  }) as any;
};
